import { CircularProgress, Container } from '@mui/material';
import React from 'react';
export function FullPageSpinner({ style = {} }) {
  return (
    <Container
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        ...style
      }}
    >
      <CircularProgress color="primary" />
    </Container>
  );
}
